export const PermissionLevels = {
  NONE: 0,
  READER: 2,
  VISITOR: 3,
  MEMBER: 6,
  OWNER: 9,
  SUPER: 10
}

export const hasPermission = (permission, requiredPermission) => {
  return permission >= requiredPermission
}

export const getPermissionMessageId = (permissionLevel) => {
  switch (permissionLevel) {
    case 9:
      return 'PERMISSION_OWNER'
    case 6:
      return 'PERMISSION_MEMBER'
    case 3:
      return 'PERMISSION_VISITOR'
    case 2:
      return 'PERMISSION_READER'
    default:
      return 'PERMISSION_' + permissionLevel
  }
}
